<div class="w-full bg-theme-pink flex flex-col pl-5 pr-5 2xs:pl-10 2xs:pr-10 md:pr-2 lg:pr-0 pt-2 2xl:pt-7 pb-5">

  <div class="w-full lg:ml-auto lg:mr-auto lg:w-[1024px] 2xl:w-[90rem] z-9994 mt-5 flex flex-col">
    <div class="text-white mb-0 2xs:pt-10 2xs:pb-10 w-full mt-5" *ngIf="showPhotos">
      <div class="mt-2 w-full aspect-square border-theme-black border-3 2xs:h-[400px]
      bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/subscription/event-18-2.webp)] 2xl:w-9/10 bg-center bg-no-repeat rounded-2xl">
      </div>
    </div>

    <h2 class="w-full mt-5 font-theme-source text-2xl sm:text-3xl leading-[1.4] lg:leading-[1.3] lg:text-5xl text-theme-black font-bold text-left">
      Pas de stress, on te dit tout sur<br />le déroulement de nos soirées !
    </h2>
    <p class="font-theme-source text-base sm:text-base lg:text-base text-theme-black mt-3">
      Vis une soirée de speed-dating en toute sérénité :<br/>une expérience encadrée qui s’adapte à toutes tes réalités.
    </p>
    <div class="w-full flex flex-row mt-5 md:mt-10">
      <div class="hidden md-home-2:block w-2/10 bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/program/hearts.svg)] bg-bottom bg-contain md:bg-cover bg-no-repeat">
      </div>
      <div class="w-full md:w-64/100 flex flex-col md:pr-15">
        <div class="w-full flex flex-col p-3 sm:p-5">
          <h3 class="w-full flex flex-row gap-5 sm:gap-7">
            <p class="font-theme-source text-4xl lg:text-5xl font-bold text-transparent text-stroke-white">19h30</p>
            <p class="font-theme-source text-xl sm:text-2xl text-theme-black font-bold leading-[2] sm:leading-[1.6] lg:leading-[2]">Accueil</p>
          </h3>
          <p class="font-theme-source text-base sm:text-base lg:text-base text-theme-black mt-3 pr-10">
            Nos animatrices t'accueillent et sont à tes côtés tout au long de la soirée pour fluidifier ton expérience.
            Elles te remettent une fiche personnalisée avec la chronologie de toutes tes rencontres.
            Tu peux t'installer puis rejoindre ta table : certain(e)s conserveront la même table quand leurs prétendant(e)s circuleront. </p>
        </div>

        <div class="w-full flex flex-col p-5 bg-theme-pink-light rounded-xl">
          <h3 class="w-full flex flex-row gap-7">
            <p class="font-theme-source text-4xl lg:text-5xl font-bold text-transparent text-stroke-white">19h50</p>
            <p class="font-theme-source text-xl sm:text-2xl text-theme-black font-bold leading-[2] sm:leading-[1.6] lg:leading-[2]">Début et rencontres</p>
          </h3>
          <p class="font-theme-source text-base sm:text-base lg:text-base text-theme-black mt-3">
            Au premier son de musique, le ballet des rencontres commençent. 7 minutes d’échanges spontanés et interactifs et 1 à 2 minutes de battement entre chaque rencontre.
            Un no-show ? Pas de souci, ton animatrice viendra échanger avec toi et tu pourras faire le point avec elle si tu le souhaites !
        </p>
        </div>

        <div class="w-full flex flex-col p-5">
          <h3 class="w-full flex flex-row gap-7">
            <p class="font-theme-source text-4xl lg:text-5xl font-bold text-transparent text-stroke-white">21h00</p>
            <p class="font-theme-source text-xl sm:text-2xl text-theme-black font-bold leading-[2] sm:leading-[1.6] lg:leading-[2]">Fin de la soirée</p>
          </h3>
          <p class="font-theme-source text-base sm:text-base lg:text-base text-theme-black mt-3">
            Fin des rencontres planifiées, c’est le moment de partager tes « coups de coeur » aux animatrices en mettant ta fiche de <span *ngIf="!isForWomenOnly">participant(e)</span><span>participante</span> dans la boîte à coups de coeur.
          </p>
        </div>

        <div class="w-full flex flex-col p-5 bg-theme-pink-light rounded-xl">
          <h3 class="w-full flex flex-row gap-7">
            <p class="font-theme-source text-4xl lg:text-5xl font-bold text-transparent text-stroke-white">Le lendemain</p>
          </h3>
          <p class="font-theme-source text-base sm:text-base lg:text-base text-theme-black mt-3">
            Réception de tous les coups de coeurs reçus et réciproques.<br/>
            Rien de figé, si tu as l'esprit de l’escalier, tu as encore la possibilité d’envoyer un coup de coeur à une personne qui tu as finalement marquée ;-)
          </p>
          <p class="font-theme-source text-base sm:text-base lg:text-base text-theme-black mt-2">
            Zéro coup de coeur ? Tu auras toujours la possibilité de changer ton vote ou d'informer
            à des <span *ngIf="!isForWomenOnly">prétendant(e)s de ton interêt pour elles/eux</span><span *ngIf="isForWomenOnly">prétendantes de ton interêt pour elles</span>,
            ce qui peut encore créer beaucoup de surprises !
          </p>
        </div>

      </div>
      <div class="hidden md:block w-26/100 bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/program/animator.svg)] bg-bottom bg-contain bg-no-repeat relative">
        <p class="absolute top-75 md-home-2:top-40 lg:top-16 xl:top-25 2xl:top-0 2xl:-mt-25 left-0 -rotate-12 font-theme-annie text-xl lg:text-2xl text-white">
          Coucou !<br/>
          Moi c’est Sarah et je serai ton hôte pour ce soir !
        </p>
      </div>
    </div>
    <div class="w-full mt-5 flex flex-col md-home-2:-ml-5">
      <p class="w-full font-theme-hallelujah text-theme-black font-bold text-xl -rotate-6 md-home-2:pl-[20%]">Fini le blue monday !</p>
      <div class="w-full md-home-2:pl-[20%] text-left mt-10 sm:mt-15">
        <p class="text-left w-[200px]">
          <app-lp-cta *ngIf="!sessionId()" text="Je booke une soirée" (onClick)="goToEvents()"></app-lp-cta>
          <app-lp-cta *ngIf="sessionId()" text="Je booke ma soirée" myRouterLink="/subscribe-v2/{{sessionId()}}/who" (onClick)="socialTrackService.trackGAEvent('lp_click_cta_program')"></app-lp-cta>
        </p>
      </div>
    </div>
  </div>
</div>
